<template>
  <div
    class="container pt-0"
    :class="
      $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
        ? 'mt-5'
        : 'mt-2'
    "
  >
    <div
      id="default-overlay-payment"
      style="
        width: 100%;
        height: 100%;
        background: #000;
        position: fixed;
        z-index: 1;
        opacity: 0;
        display: none;
        top: 0;
        left: 0;
      "
      @click="closeNav()"
    ></div>
    <div id="mySidenavPayment" class="sidenav row">
      <div class="col-md-12">
        <v-list flat>
          <v-list-item-group color="primary">
            <v-list-item
              v-for="(item, i) in items"
              :key="i"
              :ripple="false"
              style="cursor: default"
            >
              <v-list-item-icon style="caret-color: #069 !important">
                <v-icon class="mr-3" large v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="item.additionalText"
                  class="item-title-name"
                  style="
                    margin-top: 10px;
                    line-height: 20px;
                    color: #111d5e;
                    font-size: 12px;
                  "
                  v-html="item.text"
                >
                </v-list-item-title>
                <v-list-item-title
                  v-else
                  class="item-title-name"
                  style="line-height: 20px; color: #111d5e; font-size: 12px"
                  v-html="item.text"
                ></v-list-item-title>
                <v-list-item-subtitle
                  style="
                    font-size: 18px;
                    color: #069;
                    font-weight: 400;
                    line-height: 30px;
                  "
                  v-html="item.additionalText"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </div>
    <svg
      class="svg-payment"
      width="692"
      height="672"
      viewBox="0 0 692 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M518.296 201.446C517.178 200.57 516.061 199.694 514.87 198.886C502.285 189.704 489.062 181.448 475.321 174.193C434.524 152.481 388.298 137.693 341.851 126.654C341.11 126.485 340.369 126.316 339.637 126.137C338.536 125.883 337.444 125.618 336.364 125.362C334.133 124.808 331.896 124.297 329.651 123.827L324.68 122.743C323.493 122.476 322.289 122.23 321.081 121.964C320.352 121.805 319.602 121.648 318.844 121.501C306.468 118.811 294.01 116.729 281.516 115.263L280.118 115.116C264.513 113.327 248.89 113.322 233.566 115.102C206.826 118.4 181.05 129.008 158.895 144.551C158.139 145.07 157.408 145.607 156.656 146.146C155.239 147.186 153.818 148.257 152.408 149.338C151.437 150.081 150.478 150.834 149.535 151.618C142.929 156.935 136.733 162.714 130.99 168.916C127.872 172.276 124.901 175.769 122.091 179.353L120.874 180.907C117.439 185.367 114.251 190.013 111.321 194.827L110.909 195.526C102.934 208.552 97.1918 222.886 93.8904 238.007C93.3655 240.425 92.9187 242.852 92.5501 245.286L92.3524 246.528L92.2742 247.148C91.113 255.357 90.5349 263.679 90.5441 272.054C90.5029 281.785 91.1279 291.483 92.045 301.105C93.3513 315.417 95.5516 329.706 98.6333 343.888L98.769 344.532C100.138 350.657 101.724 356.719 103.528 362.719L103.6 362.775C104.864 366.955 106.244 371.093 107.74 375.192C107.79 375.375 107.861 375.556 107.936 375.758C110.148 381.773 112.616 387.684 115.389 393.477L116.035 394.807C118.082 399.027 120.295 403.15 122.675 407.177C135.981 430.003 154.226 449.821 173.728 468.134C213.103 505.176 258.513 537.168 309.016 560.038C315.848 563.137 322.772 566.061 329.786 568.812C330.726 569.173 331.669 569.553 332.617 569.903C334.106 570.479 335.612 571.032 337.153 571.666C337.779 571.906 338.426 572.145 339.062 572.374C344.836 574.512 350.679 576.505 356.589 578.355L359.697 579.34C362.84 580.281 366.108 581.284 369.339 582.187C372.309 583.027 375.316 583.844 378.334 584.597C378.825 584.713 379.295 584.831 379.778 584.958C405.476 591.306 432.732 594.577 459.151 589.559C460.97 589.194 462.765 588.809 464.537 588.406C467.187 587.797 469.825 587.088 472.451 586.279L474.299 585.704L474.977 585.482L475.454 585.319L475.722 585.225C477.016 584.787 478.35 584.347 479.577 583.821C480.804 583.296 482.137 582.783 483.402 582.233L483.506 582.1L483.994 581.874C484.986 581.45 485.962 580.997 486.936 580.596L487.917 580.111L488.296 579.925L489.844 579.114C496.886 575.442 503.455 571.02 509.441 565.919C512.752 563.091 515.862 560.049 518.754 556.809C523.149 551.911 526.912 546.487 529.968 540.644C530.433 539.755 530.877 538.867 531.297 537.96C534.935 530.397 536.854 522.046 536.931 513.444C536.922 502.169 533.44 491.486 529.338 481.052L528.925 479.994C528.231 478.231 527.519 476.491 526.807 474.751C524.322 468.664 521.812 462.559 519.5 456.376C517.355 450.646 515.378 444.851 513.735 438.977C512.072 433.062 510.842 427.069 510.057 421.046C509.943 420.151 509.839 419.245 509.755 418.337C508.64 407.498 509.501 396.7 512.297 386.454C514.935 377.272 519.506 368.816 526.82 362.851C528.882 361.153 531.144 359.694 533.566 358.501C538.132 356.24 542.602 354.028 546.835 351.721C554.609 347.776 561.754 342.82 568.091 336.979C574.516 330.846 579.209 323.16 581.77 314.577C582.219 313.137 582.564 311.706 582.897 310.193C584.358 303.522 584.62 296.566 583.671 289.626C583.559 288.803 583.426 287.983 583.293 287.162C580.159 269.031 569.485 252.03 557.196 237.758C545.581 224.333 532.528 212.149 518.296 201.446Z"
        fill="#069"
      />
    </svg>
    <v-app>
      <!-- <h3>Setup your company account</h3>
            <p class="lead text-center">Make payment</p> -->
      <v-form @submit.prevent="auth_request()">
        <v-container>
          <v-row>
            <v-col md="4" lg="4" cols="12">
              <v-card class="right-card pt-1 pb-1 pl-4 pr-2">
                <h3
                  style="font-size: 16px !important"
                  class="text-left mb-3 mt-3"
                >
                  Selected Apps: {{ selectedServices.length }}
                </h3>
                <v-row
                  v-for="service in selectedServices"
                  :key="service.service_id"
                >
                  <v-col class="pt-0" md="1" lg="1" cols="2">
                    <i
                      style="color: #111d5e"
                      :class="getIcon(service.service_name) + ' selected_icons'"
                    ></i>
                  </v-col>
                  <v-col class="pt-0 my-auto" md="10" lg="10" cols="8">
                    <span style="font-size: 11px">{{
                      service.service_name
                    }}</span>
                  </v-col>
                </v-row>
                <!-- <v-row class="pt-7">
                  <v-col md="9" offset="1" class="pb-0">
                    <v-radio-group v-model="timeFrame" row>
                      <v-row>
                        <v-col md="4" lg="4" cols="4">
                          <v-radio
                            label="Monthly"
                            value="monthly"
                            color="#069"
                            :disabled="true"
                          ></v-radio>
                        </v-col>
                        <v-col md="4" lg="4" offset-lg="2" offset-md="2" cols="4" offset="1">
                          <v-radio
                            label="Annually"
                            value="annually"
                            color="#069"
                          ></v-radio>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row> -->
                <div class="pb-2 mt-4">
                  <h3
                    v-if="timeFrame === 'annually'"
                    style="color: #069 !important"
                  >
                    ₦{{ (VAT_FEE + amount) | number_with_commas }}/year
                  </h3>
                  <h3 v-else style="color: #069 !important">
                    ₦{{ Math.ceil((VAT_FEE + amount) / 12) }}/monthly
                  </h3>
                </div>
              </v-card>
            </v-col>
            <v-col md="7" lg="7" offset-lg="1" offset-md="1" cols="12">
              <v-radio-group v-model="picked">
                <!-- <v-row :style="feature.header.toLowerCase() == 'pay through bank transfer' ? 'display: none !important;' : null" v-for="feature in features" :key="feature.id"> -->
                <v-row v-for="feature in features" :key="feature.id">
                  <v-col md="1" lg="1" cols="1" class="my-auto">
                    <v-radio
                      :value="feature.header"
                      color="#069"
                      @click="pickedFunc()"
                    ></v-radio>
                  </v-col>
                  <v-col md="10" lg="10" cols="11">
                    <!-- <v-card
                                    elevation="2"
                                    outlined
                                    >
                                        <h2>Game</h2>
                                    </v-card> -->
                    <v-card
                      v-if="
                        picked.toLowerCase() === 'pay through bank transfer' &&
                        feature.header.toLowerCase() ===
                          'pay through bank transfer'
                      "
                      @click.prevent="
                        /*
  picked.toLowerCase() === 'pay through bank transfer' &&
    feature.header.toLowerCase() ===
    'pay through bank transfer'
    ? openNav()
    : ''
*/
                      "
                      class="feature-card"
                    >
                      <v-row>
                        <v-col class="text-center" md="4" lg="4" cols="4">
                          <v-icon x-large color="#069">
                            {{ feature.icon }}
                          </v-icon>
                        </v-col>
                        <v-col class="my-auto" md="7" lg="7" cols="7">
                          <h3
                            style="font-size: 140% !important"
                            class="card-h3 text-left mx-2"
                          >
                            {{ feature.header }}
                          </h3>
                          <p class="card-p">{{ feature.paragraph }}</p>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-card v-else class="feature-card">
                      <v-row>
                        <v-col class="text-center" md="4" lg="4" cols="4">
                          <v-icon x-large color="#069">
                            {{ feature.icon }}
                          </v-icon>
                        </v-col>
                        <v-col class="my-auto" md="7" lg="7" cols="7">
                          <h3
                            style="font-size: 140% !important"
                            class="card-h3 text-left mx-2"
                          >
                            {{ feature.header }}
                          </h3>
                          <p class="card-p">{{ feature.paragraph }}</p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-radio-group>
              <v-row class="mt-5">
                <v-col class="pb-6 text-right" cols="6" md="6">
                  <v-btn
                    type="submit"
                    x-large
                    dark
                    class="create-submit"
                    :class="
                      $vuetify.breakpoint.name == 'xs' ||
                      $vuetify.breakpoint.name == 'sm'
                        ? 'w-100'
                        : null
                    "
                    @click="goBack(2)"
                  >
                    Previous
                  </v-btn>
                </v-col>
                <v-col class="pb-6 text-left" cols="6" md="6">
                  <v-btn
                    type="submit"
                    x-large
                    dark
                    class="create-submit"
                    :class="
                      $vuetify.breakpoint.name == 'xs' ||
                      $vuetify.breakpoint.name == 'sm'
                        ? 'w-100'
                        : null
                    "
                    @click.prevent="
                      picked.toLowerCase() == 'pay through bank transfer'
                        ? payWithTransfer()
                        : payWithPaystack()
                    "
                  >
                    {{
                      picked.toLowerCase() === "pay through bank transfer"
                        ? btnTxt2
                        : btnTxt
                    }}
                    <v-icon :style="!isLoading ? 'display: none' : ''"
                      >fas fa-circle-notch fa-spin</v-icon
                    >
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <!-- <v-col
                        md="3"
                        sm="2"
                        offset="1"
                        >
                            <transition
                            mode="out-in" 
                            type="animation"
                            enter-active-class="animate__animated animate__fadeInRight"
                            leave-active-class="animate__animated animate__fadeOutRight">
                                <component :is="cardName"></component>
                            </transition>
                        </v-col> -->
          </v-row>
        </v-container>
      </v-form>

      <div class="text-center">
        <v-dialog v-model="paidDialog" width="500">
          <v-card>
            <v-card-text class="pt-5">
              <div class="col-md-8 mx-auto text-center pb-5">
                <img
                  src="@/assets/graphics/check.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h3 class="msg pl-5 pr-5 text-center" style="display: block">
                Payment complete!
              </h3>
            </v-card-text>

            <v-divider class="mb-0"></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#069" text @click="paidDialog = false">
                <strong>Close</strong>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <div class="text-center">
        <v-dialog v-model="chooseOne" width="500">
          <v-card>
            <v-card-text class="pt-5">
              <div class="col-md-8 mx-auto text-center pb-5">
                <img
                  src="@/assets/graphics/attention.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h3 class="msg pl-5 pr-5 text-center" style="display: block">
                Please select an option
              </h3>
            </v-card-text>

            <v-divider class="mb-0"></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#069" text @click="chooseOne = false">
                <strong>Close</strong>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <div class="text-center">
        <v-dialog persistent v-model="bankTransferDialog" width="500">
          <v-card>
            <v-card-text class="pt-5">
              <div class="col-md-8 mx-auto text-center pb-5">
                <img
                  src="@/assets/graphics/attention.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <div
                class="msg pl-5 pr-5 text-left"
                style="display: block; font-size: 17px"
              >
                <div>
                  BANK NAME:
                  <span style="font-weight: bold">ACCESS BANK PLC</span>
                </div>
                <div>
                  ACCOUNT NAME:
                  <span style="font-weight: bold"
                    >KYLIAN RESOURCES LIMITED</span
                  >
                </div>
                <div>
                  ACCOUNT NUMBER:
                  <span style="font-weight: bold">1509961960</span>
                </div>
                <div>
                  Email an evidence of successful transfer to
                  <a
                    style="font-weight: bold"
                    href="mailto:billing@kylianerp.com"
                    >billing@kylianerp.com</a
                  >
                  or call us on
                  <a style="font-weight: bold" href="tel:+2347080593338"
                    >07080593338</a
                  >,
                  <a style="font-weight: bold" href="tel:+2348055257262"
                    >08055257262</a
                  >, or
                  <a style="font-weight: bold" href="tel:+2349076381366"
                    >09076381366</a
                  >.
                </div>
              </div>
            </v-card-text>

            <v-divider class="mb-0"></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#069" text @click="doneWithTransfer()">
                <strong>Done</strong>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import { BASE_URL } from "@/main";
export default {
  props: {
    amount: {
      type: Number,
      required: true,
    },
    selectedServices: {
      type: Array,
      required: true,
    },
    company_subscription: {
      type: Number,
      required: true,
    },
    serviceSelections: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      bankTransferDialog: false,
      chooseOne: false,
      paidDialog: false,
      payment_ref: "",
      isLoading: false,
      btnTxt: "Pay",
      btnTxt2: "Pay via Transfer",
      picked: "Pay with Credit Card",
      features: [
        {
          id: 1,
          icon: "mdi-cash",
          header: "Pay through Bank Transfer",
          checked: false,
        },
        {
          id: 2,
          icon: "mdi-credit-card-outline",
          header: "Pay with Credit Card",
          checked: false,
        },
      ],
      timeFrame: "annually",
      items: [
        {
          text: "Send money to the account number below",
          additionalText:
            "ACCOUNT NAME: KYLIAN RESOURCES LIMITED<br>BANK: ACCESS BANK PLC<br>ACCOUNT NO: 1509961960",
          icon: "mdi-numeric-1-circle-outline",
        },
        {
          text: "Email screenshot  of successful transfer to <br>billing@kylianerp.com",
          icon: "mdi-numeric-2-circle-outline",
        },
        {
          text: "It takes at most 24 hours to confirm payment. <br>Then we take it up from there.",
          icon: "mdi-numeric-3-circle-outline",
        },
      ],
    };
  },
  computed: {
    ...mapState(["paystackKey", "VAT"]),
    ...mapGetters(["validEmployeeId", "authCompanyData", "authUserData"]),
    VAT_FEE() {
      let _this = this,
        result = 0;
      result = (_this.VAT / 100) * _this.amount;
      return result;
    },
    finalAmount() {
      if (this.timeFrame !== "monthly") {
        return this.VAT_FEE + this.amount;
      } else {
        return Math.ceil((this.VAT_FEE + this.amount) / 12);
      }
    },
    isTrial() {
      return this.company_subscription === 1 ? true : false;
    },
  },
  methods: {
    goBack(step) {
      this.$emit("goBack", {
        step,
      });
    },
    doneWithTransfer() {
      this.bankTransferDialog = false;
      this.$store.dispatch("logout_request");
    },
    openNav() {
      if (screen.width > 450) {
        document.getElementById("mySidenavPayment").style.width = "40%";
        // document.getElementById("mySidenav").style.paddingLeft = "30px";
        // document.getElementById("mySidenav").style.paddingRight = "30px";
        document.getElementById("default-overlay-payment").style.opacity =
          "0.1";
        document.getElementById("default-overlay-payment").style.display =
          "block";
        console.log("open");
      } else {
        document.getElementById("mySidenavPayment").style.width = "80%";
        document.getElementById("default-overlay-payment").style.opacity =
          "0.1";
        document.getElementById("default-overlay-payment").style.display =
          "block";
      }
    },
    closeNav() {
      console.log("close");
      document.getElementById("mySidenavPayment").style.width = "0";
      // document.getElementById("mySidenav").style.paddingLeft = "0px";
      // document.getElementById("mySidenav").style.paddingRight = "0px";
      document.getElementById("default-overlay-payment").style.opacity = "0";
      document.getElementById("default-overlay-payment").style.display = "none";
    },
    getIcon(name) {
      if (name.toLowerCase() == "onboarding") {
        return "fal fa-users";
      } else if (name.toLowerCase() == "attendance") {
        return "fal fa-clipboard-user";
      } else if (name.toLowerCase() == "timesheets") {
        return "fal fa-file-lines";
      } else if (name.toLowerCase() == "absence or leave") {
        return "fal fa-island-tropical";
      } else if (name.toLowerCase() == "medicals") {
        return "fal fa-notes-medical";
      } else if (name.toLowerCase() == "assets") {
        return "fal fa-computer-speaker";
      } else if (name.toLowerCase() == "file management") {
        return "fal fa-paste";
      } else if (name.toLowerCase() == "payroll") {
        return "fal fa-money-check-edit";
      } else if (name.toLowerCase() == "payslip") {
        return "fal fa-money-check-edit";
      } else if (name.toLowerCase() == "travel management") {
        return "fal fa-plane-departure";
      } else if (name.toLowerCase() == "recruitment") {
        return "fal fa-handshake";
      } else if (name.toLowerCase() == "projects") {
        return "fal fa-tasks";
      } else if (name.toLowerCase() == "loan") {
        return "fal fa-coins";
      } else if (name.toLowerCase() == "tasksheets") {
        return "fal fa-file-spreadsheet";
      } else if (name.toLowerCase() == "requisitions") {
        return "fal fa-money-check";
      } else if (name.toLowerCase() == "dockets") {
        return "fal fa-scale-balanced";
      } else if (name.toLowerCase() == "performance") {
        return "fal fa-chart-line-up";
      } else {
        return "fal fa-question";
      }
    },
    changeStep(step) {
      this.$emit("step", step);
    },
    pickedFunc() {
      let _this = this;
      this.$emit("paymentPick", _this.picked);
      if (this.picked.toLowerCase() === "pay through bank transfer") {
        // this.openNav();
      }
    },
    auth_request() {
      //
    },
    // changeStep (step) {
    //     this.$emit('step', step);
    // }
    confirmBankTransfer() {
      const _this = this;
      let letters = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
      ];
      let ref = "";
      for (let i = 0; i <= 10; i++) {
        if (i === 5) {
          ref += new Date().getTime();
          continue;
        }
        // ref += Math.floor(letters[Math.random() * letters.length])
        ref +=
          letters[Math.floor(Math.random() * letters.length)].toUpperCase();
      }
      _this.btnTxt = "";
      _this.btnTxt2 = "";
      _this.isLoading = true;
      axios
        .post(`${BASE_URL}addservice`, {
          payment_ref: ref,
          company_id: _this.serviceSelections.company_id,
          amount: _this.finalAmount,
          services: _this.serviceSelections.services,
          company_subscription: 1, //_this.serviceSelections.company_subscription,
          user_id: _this.authUserData.id,
        })
        .then(function () {
          _this.bankTransferDialog = true;
          _this.isLoading = false;
          _this.btnTxt = "Pay";
          _this.btnTxt2 = "Pay via Transfer";
        })
        .catch(function () {
          _this.$swal.fire(
            "Error!",
            "There was an error in setting up your account. Please contact the systems admin or try again.",
            "error"
          );
          _this.isLoading = false;
          _this.btnTxt = "Pay";
          _this.btnTxt2 = "Pay via Transfer";
        })
        .then(function () {
          //
        });
    },
    payWithTransfer() {
      const _this = this;
      _this.$swal
        .fire({
          title: "Are you sure you want to pay via bank transfer?",
          showCancelButton: true,
          confirmButtonText: `Yes, Proceed`,
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            _this.confirmBankTransfer();
          }
        });
    },
    payWithPaystack() {
      let letters = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
      ];
      let ref = "";
      for (let i = 0; i <= 10; i++) {
        if (i === 5) {
          ref += new Date().getTime();
          continue;
        }
        // ref += Math.floor(letters[Math.random() * letters.length])
        ref +=
          letters[Math.floor(Math.random() * letters.length)].toUpperCase();
      }
      let _this = this;
      let handler = window.PaystackPop.setup({
        key: this.paystackKey, // Replace with your public key
        email: this.authUserData.email,
        amount: this.finalAmount * 100, //document.getElementById("amount").value * 100,
        ref, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
        // label: "Optional string that replaces customer email"
        callback: function (response) {
          _this.payment_ref = response.reference;
          _this.paidDialog = true;
          setTimeout(function () {
            _this.$emit("paid", _this.payment_ref);
            _this.paidDialog = false;
          }, 1000);
          // _this.$watch("paidDialog", newValue => {
          //   if (newValue === false) {
          //     _this.changeStep(4);
          //   }
          // });
        },
      });
      handler.openIframe();
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 991px) {
  .create-submit {
    height: 45px !important;
  }
}

$primary-color: #069;
$text-field-color: #4e4e52;

.fa-eye,
.fa-eyeslash {
  color: $primary-color !important;
}

.company-name .v-text-field--single-line {
  .v-text-field__suffix,
  .v-text-field__prefix {
    color: $text-field-color !important;
    background-color: #00669914;
    padding: 10px;
    height: 38px;
  }
}

.v-label {
  margin: auto;
  font-size: 14px !important;
  color: #111d5e !important;
}

// .v-text-field__suffix, .v-text-field__prefix, input {
//     color: $text-field-color !important;
//     background-color: #00669914;
//     padding: 10px;
//     height: 48px;
// }
.v-text-field__suffix {
  border-radius: 0px 5px 5px 0px;
  padding-top: 8px;
  padding-left: 8px !important;
}

.v-text-field__prefix {
  border-radius: 5px 0px 0px 5px;
  padding-top: 8px;
  padding-right: 8px !important;
  text-decoration: underline;
}

.company-name .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) {
  label {
    margin-left: 2%;
  }

  input {
    text-indent: 3%;
  }
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: 0px 0px 50px 0px #00000014 !important;
}

.v-text-field__details {
  padding-left: 0 !important;
}

.theme--light.v-messages {
  color: $primary-color !important;
}

.company-name
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  padding: 0px !important;
}

h3 {
  font-family: Work Sans;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -0.6252632141113281px;
  text-align: center;
  color: #111d5e;
}

label {
  color: #999 !important;
}
</style>
<style lang="scss" scoped>
.sidenav {
  height: 100%;
  width: 0px;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 0px;
  padding-right: 0;
  padding-left: 0;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #000000;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }

  .sidenav a {
    font-size: 18px;
  }
}

.svg-payment {
  position: absolute;
  top: -100px;
  right: 550px;
}

h3 {
  font-size: 21px;
}

i.fas {
  padding: 20px 0px;
}

.v-input--radio-group--column .v-input--radio-group__input {
  flex-direction: initial !important;
}

.v-form {
  margin: 0%;
}

$primary-color: #069;

#small-link {
  color: $primary-color !important;
}

.space-top {
  padding-top: 20px;
}

.create-submit {
  width: 70%;
  height: 60px;
  border-radius: 10px !important;
  background-color: #069 !important;
  text-transform: initial !important;
  font-weight: 600;

  span {
    text-transform: initial;
  }
}

.lead {
  margin-bottom: 0;
  padding: 2% 0 0 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.6252632141113281px;
  text-align: left;
}

.card-h3 {
  font-size: 17px;
  margin-top: 10px;
}

.card-p {
  font-size: 13px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
  color: #111d5e !important;
}

.feature-card div div .mdi {
  font-size: 90px !important;
}

.feature-card {
  box-shadow: 0px 0px 50px 0px #00000014 !important;
  border-radius: 10px !important;
  border: 1px solid #fff;
}

.v-input--selection-controls {
  margin-top: 0px !important;
}

.v-messages {
  display: none !important;
}

.right-card {
  padding: 60px 0px;
  box-shadow: 0px 0px 50px 0px #00000014 !important;
  border-radius: 10px !important;
  text-align: left;
}

.mdi-progress-question {
  bottom: 1px;
}
</style>
